import {memo} from 'react'

import {restApi} from '../../../../../services/rest'
import type {ChangeId} from '../../../../../types'
import SequenceLoader from '../../../../common/SequenceLoader/SequenceLoader'
import {useBuildProblemsTreeArg} from '../../../BuildProblems/BuildProblemsTree/BuildProblemsTree.hooks'
import {useTestOccurrenceTreeArg} from '../../../Tests/TestsTree/TestsTree.hooks'
import {getChange} from '../../Changes.selectors'

import ChangeProblemsTree from './ChangeProblemsTree/ChangeProblemsTree'
import {getChangeProblemsTreeLocator} from './ChangeProblemsTree/ChangeProblemsTree.utils'
import ChangeTestsTree from './ChangeTestsTree/ChangeTestsTree'
import {getChangeTestsTreeLocator} from './ChangeTestsTree/ChangeTestsTree.utils'

import {useAppSelector} from 'src/hooks/react-redux'

type Props = {
  changeId: ChangeId
}

function ProblemsTestsTab({changeId}: Props) {
  const personal = useAppSelector(state => getChange(state, changeId)?.personal)
  const changeProblemsTreeLocator = getChangeProblemsTreeLocator(changeId, personal)
  const changeTestsTreeLocator = getChangeTestsTreeLocator(changeId, personal)

  const problemsArg = useBuildProblemsTreeArg(changeProblemsTreeLocator)
  const {noProblems} = restApi.endpoints.getProblemOccurrenceTree.useQueryState(problemsArg, {
    selectFromResult: ({data}) => ({
      noProblems: data?.tree.leaf?.length === 0,
    }),
  })
  const testsArg = useTestOccurrenceTreeArg(changeTestsTreeLocator)
  const {noTests} = restApi.endpoints.getTestOccurrenceTree.useQueryState(testsArg, {
    selectFromResult: ({data}) => ({
      noTests: data?.tree.leaf?.length === 0,
    }),
  })

  if (noProblems && noTests) {
    return <span>{'No problems and failed tests'}</span>
  }

  return (
    <SequenceLoader>
      <ChangeProblemsTree seqKey="ChangeProblemsTree" changeId={changeId} />
      <ChangeTestsTree seqKey="ChangeTestsTree" changeId={changeId} />
    </SequenceLoader>
  )
}

export default memo(ProblemsTestsTab)
